import { Schema } from '.';

const repSchema: Schema = [
  { name: 'USER_ID', type: 'STRING', mode: 'REQUIRED', nomap: true },
  { name: 'GROUP_ID', type: 'STRING', mode: 'REQUIRED', nomap: true },
  { name: 'INGEST_ID', type: 'STRING', mode: 'REQUIRED', nomap: true },
  { name: 'DELETED', type: 'TIMESTAMP', mode: 'NULLABLE', nomap: true },
  { name: 'COMPONENT_TYPOLOGY', type: 'STRING', mode: 'REQUIRED' },
  { name: 'CONTRACT_ID', type: 'STRING', mode: 'NULLABLE' },
  { name: 'CONTRACT_VERSION', type: 'STRING', mode: 'NULLABLE' },
  { name: 'CONTRACT_TYPOLOGY', type: 'STRING', mode: 'NULLABLE' },
  { name: 'COUNTERPARTY', type: 'STRING', mode: 'NULLABLE' },
  { name: 'CUSTOM_BENCHMARK_1', type: 'NUMERIC', mode: 'NULLABLE' },
  { name: 'CUSTOM_BENCHMARK_2', type: 'NUMERIC', mode: 'NULLABLE' },
  { name: 'CUSTOM_BENCHMARK_3', type: 'NUMERIC', mode: 'NULLABLE' },
  { name: 'CUSTOM_BENCHMARK_4', type: 'NUMERIC', mode: 'NULLABLE' },
  { name: 'CUST_TYPE', type: 'STRING', mode: 'NULLABLE' },
  { name: 'DESCRIPTION', type: 'STRING', mode: 'NULLABLE' },
  { name: 'ECONOMIC_IMPACT', type: 'STRING', mode: 'NULLABLE' },
  { name: 'EFFECTIVE_DATE', type: 'DATE', mode: 'NULLABLE' },
  { name: 'LEGAL_ENTITY', type: 'STRING', mode: 'NULLABLE' },
  { name: 'EVENT_ACTOR', type: 'STRING', mode: 'NULLABLE' },
  { name: 'FIXED_RATE', type: 'NUMERIC', mode: 'REQUIRED' },
  { name: 'LEG1_CURRENCY', type: 'STRING', mode: 'REQUIRED' },
  { name: 'LEG1_DAY_COUNT', type: 'STRING', mode: 'REQUIRED' },
  { name: 'LEG1_FIXING', type: 'STRING', mode: 'REQUIRED' },
  { name: 'LEG1_NOTIONAL', type: 'NUMERIC', mode: 'REQUIRED' },
  { name: 'LEG1_PAY_FREQUENCY', type: 'STRING', mode: 'REQUIRED' },
  { name: 'LEG2_CURRENCY', type: 'STRING', mode: 'REQUIRED' },
  { name: 'LEG2_DAY_COUNT', type: 'STRING', mode: 'REQUIRED' },
  { name: 'LEG2_FIXING', type: 'STRING', mode: 'REQUIRED' },
  { name: 'LEG2_NOTIONAL', type: 'NUMERIC', mode: 'REQUIRED' },
  { name: 'LEG2_PAY_FREQUENCY', type: 'STRING', mode: 'REQUIRED' },
  { name: 'MARGIN_CCY', type: 'STRING', mode: 'NULLABLE' },
  { name: 'MATURITY_DATE', type: 'DATE', mode: 'NULLABLE' },
  { name: 'NET_PL', type: 'NUMERIC', mode: 'NULLABLE' },
  { name: 'ORIG_MARGIN', type: 'NUMERIC', mode: 'NULLABLE' },
  { name: 'PAY_LEG', type: 'STRING', mode: 'REQUIRED' },
  { name: 'PL_CCY', type: 'STRING', mode: 'NULLABLE' },
  { name: 'PORTFOLIO', type: 'STRING', mode: 'NULLABLE' },
  { name: 'REPORT_DATE', type: 'DATE', mode: 'NULLABLE' },
  { name: 'ROOT_CONTRACT_ID', type: 'STRING', mode: 'NULLABLE' },
  { name: 'STRATEGY', type: 'STRING', mode: 'NULLABLE' },
  { name: 'SYSTEM', type: 'STRING', mode: 'NULLABLE' },
  { name: 'TENOR', type: 'STRING', mode: 'NULLABLE' },
  { name: 'TRADER_ID', type: 'STRING', mode: 'NULLABLE' },
  { name: 'TRADE_DATETIME', type: 'TIMESTAMP', mode: 'REQUIRED' },
  { name: 'TRADE_EVENT', type: 'STRING', mode: 'NULLABLE' },
  { name: 'TRADE_ID', type: 'STRING', mode: 'REQUIRED' },
  { name: 'TRADE_INSERTION_DATETIME', type: 'TIMESTAMP', mode: 'NULLABLE' },
].sort((a, b) => {
  if (a.name < b.name) return -1;
  if (a.name > b.name) return 1;
  return 0;
});

export default repSchema;
